module.exports = __webpack_public_path__ + "static/media/map02.897b19e1.gif";